import { render } from "./integrationRedirectComponent.vue?vue&type=template&id=7795bfe6"
import script from "./integrationRedirectComponent.vue?vue&type=script&lang=js"
export * from "./integrationRedirectComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__